import { useQuery } from "@tanstack/react-query";
import { StatsModel } from "../stats/types";

export const useGetStats = (sport: string, type: string, enabled: boolean = true, site?: string, slateId?: string) => {
  const params: Record<string, string> = {
    sport,
    type,
  };

  // Add site parameter for types that need it (top stacks)
  if (site) {
    params.site = site;
  }

  // Add slateId parameter for MLB top stacks
  if (slateId) {
    params.slateId = slateId;
  }

  return useQuery<StatsModel[], Error>({
    queryKey: [`stats-${sport}-${type}${site ? `-${site}` : ''}${slateId ? `-${slateId}` : ''}`],
    queryFn: async () => {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/api/slatedata/stats?` +
          new URLSearchParams(params)
      ).then((res) => res.json());

      // Add id field for DataGrid row identification if not present
      return data.map((item: StatsModel, index: number) => ({
        ...item,
        id: item.id || `${(item as any).name || (item as any).team}-${index}`,
      }));
    },
    refetchOnWindowFocus: false,
    enabled: enabled && !!sport && !!type,
  });
};
